// @ts-ignore:next-line
import {useStats} from 'react-instantsearch';

export function NumberOfHits() {
  const {nbHits} = useStats();

  return (
    <div className="border-b border-divider pb-6 mb-6 lg:border-0 lg:pb-0 lg:mb-0">
      <span className="text-sm">{nbHits} tuotetta</span>
    </div>
  );
}
